import $i from "~/i18n";
export const getInst = async ({ commit, dispatch }, payload) => {
  let { data } = await axios.post("/course-insts/get", {
    course_id: payload.id
  });
  if (data.instructors.length > 0) {
    data.instructors.forEach(e => {
      dispatch("getInstractor", e.user_id);
    });
  }
};
export const getByCat = async ({ commit }, payload) => {
  try {
    let body = {
      page_num: payload.page || 1,
      subcategory: parseInt(payload.id)
    };
    let res = await axios.post(`/course/get-course-by-sub`, body);
    if (res.status === 200) {
      commit("SET_DATA", { data: res.data.last, id: "someCatsListCourse" });
    }
  } catch (e) {
    return Promise.reject(e);
  }
};
export const getLastCourse = async ({ commit }, payload) => {
  try {
    let res = await axios.post(`/course/get-last`);
    if (res.status === 200) {
      commit("SET_DATA", { data: res.data.last, id: "lastCourse" });
    }
  } catch (e) {
    return Promise.reject(e);
  }
};
export const startEnroll = async ({ commit }, payload) => {
  try {
    let { data } = await axios.post("/enroll/enroll-free-course", {
      course_id: payload.id
    });
    if (data.status !== 200) {
      if (data.state == 400) {
        commit(
          "notifications/error",
          {
            message: "این دوره در لیست دوره های شما موجود است",
            title: "درخواست تکراری"
          },
          { root: true }
        );
      }
      return;
    }
    commit(
      "notifications/success",
      { message: " به لیست دوره های شما اضافه شد", title: "دوره رایگان" },
      { root: true }
    );
  } catch (e) {
    return Promise.reject(e);
  }
};
export const getCourseDetail = async ({ commit, dispatch }, payload) => {
  try {
    let id = payload.id;
    let { data } = await axios.post(`/course/get-course-detail`, { id: id });
    if (data.state !== 200) return;
    if (!payload.getBio) {
      dispatch("getInstractor", data.course_detail[0].creator_id);
    }
    commit("SET_DATA", { data: data.course_detail[0], id: "courseDetail" });
  } catch (e) {
    return Promise.reject(e);
  }
};
export const getInstractor = async ({ commit }, payload) => {
  let { data } = await axios.post(`/bio/get-public-bio`, { id: payload });
  if (data.state !== 200) return;
  commit("SET_DATA", { data: data.bio[0], id: "instractor", isPush: true });
};
export const getCourseCounts = async ({ commit }, payload) => {
  try {
    let id = payload.id;
    let { data } = await axios.post(`/course/get-season-lectures-count`, {
      course_id: id
    });
    if (data.state !== 200) return;
    commit("SET_DATA", { data: data.counts, id: "counts" });
  } catch (e) {
    return Promise.reject(e);
  }
};
export const getGoals = async ({ commit }, payload) => {
  try {
    let id = payload.id;
    let { data } = await axios.post(`/course-goals/get`, { course_id: id });
    if (data.state !== 200) return;
    commit("SET_DATA", { data: data.goals, id: "goals" });
  } catch (e) {
    return Promise.reject(e);
  }
};
export const courseMsg = async ({ commit }, payload) => {
  try {
    let id = payload.id;
    let { data } = await axios.post(`/course-msg/get`, { course_id: id });
    if (data.state !== 200) return;
    commit("SET_DATA", { data: data.msgs, id: "msgs" });
  } catch (e) {
    return Promise.reject(e);
  }
};
export const addToFavorite = async ({ commit }, payload) => {
  try {
    let id = payload;
    let { data } = await axios.post(`/wishlist/set`, { course: parseInt(id) });
    if (data.state !== 200) return;
    commit(
      "notifications/success",
      { message: "به لیست علاقه مندی ها افزوده شد", title: "" },
      { root: true }
    );
    commit("setFavorite");
  } catch (e) {
    return Promise.reject(e);
  }
};
export const removeFavorite = async ({ commit }, payload) => {
  try {
    let id = payload;
    let { data } = await axios.post(`/wishlist/delete`, { id: id });
    if (data.state !== 200) return;
    commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
    commit("setFavorite");
  } catch (e) {
    return Promise.reject(e);
  }
};
export const cheackFavorite = async ({ commit }, payload) => {
  try {
    let id = payload.id;
    let { data } = await axios.post(`/wishlist/is`, {
      course_id: parseInt(id)
    });
    if (data.state !== 200) return;
    commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
    // commit('setFavorite',data.isFave)
    // TODO Update
  } catch (e) {
    return Promise.reject(e);
  }
};
export const getSections = async (context, payload) => {
  try {
    let { data } = await axios.post("/section/get-all-sections", {
      course_id: parseInt(payload.id)
    });
    if (data.state != 200) return;
    return data.sections;
  } catch (e) {
    return Promise.reject(e);
  }
};
export const getLects = async (context, payload) => {
  try {
    let { data } = await axios.post("/lecture/get-section-lectures", {
      id: parseInt(payload.id)
    });
    if (data.state != 200) return;
    return data.lectures;
  } catch (e) {
    return Promise.reject(e);
  }
};

export const getVideo = async ({ commit, dispatch }, payload) => {
  let url = "/lecture/get-video-lecture";
  if ((await dispatch("detectmob")) || (await dispatch("getIdBrowser")) === 2) {
    url = "/lecture/get-video-lecture-for-dl";
  }
  let { data } = await axios.post(url, {
    id: payload.id
  });
  if (data.state != 200) return data;
  return data;
};
export const detectmob = async () => {
  if (
    // navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;
  }
};

export const getIdBrowser = async () => {
  var aKeys = ["MSIE", "Firefox", "Safari", "Chrome", "Opera"],
    sUsrAg = navigator.userAgent,
    nIdx = aKeys.length - 1;
  for (nIdx; nIdx > -1 && sUsrAg.indexOf(aKeys[nIdx]) === -1; nIdx--);
  return nIdx;
};



// WEBPACK FOOTER //
// ./src/store/modules/courses/actions.js